// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4010a400","455":"641a7306","644":"fa5d7b96"}[chunkId] + ".chunk.js";
};